import type { RouteObject } from 'react-router-dom';

import { AuthLayout } from '@/components/layout/auth-layout';
import { routes } from '@/config/routes';

import { RequireFlowState } from './guards/require-flow-state';

export const publicRoutes: RouteObject[] = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: routes.login,
        lazy: async () => {
          const m = await import('@/pages/auth/login.page');
          return { Component: m.LoginPage };
        },
      },
      {
        path: routes.signup,
        lazy: async () => {
          const m = await import('@/pages/auth/signup.page');
          return { Component: m.SignupPlaceholderPage };
        },
      },
      {
        element: <RequireFlowState stateKey="phone" fallback={routes.login} />,
        children: [
          {
            path: routes.loginVerifyOtp,
            lazy: async () => {
              const m = await import('@/pages/auth/login-otp.page');
              return { Component: m.LoginOtpPage };
            },
          },
        ],
      },
      {
        path: routes.forgotPassword,
        lazy: async () => {
          const m = await import('@/pages/auth/forgot-password.page');
          return { Component: m.ForgotPasswordPage };
        },
      },
      {
        element: <RequireFlowState stateKey="phone" fallback={routes.forgotPassword} />,
        children: [
          {
            path: routes.forgotVerify,
            lazy: async () => {
              const m = await import('@/pages/auth/forgot-otp.page');
              return { Component: m.ForgotOtpPage };
            },
          },
        ],
      },
      {
        path: routes.forgotReset,
        lazy: async () => {
          const m = await import('@/pages/auth/reset-password.page');
          return { Component: m.ResetPasswordPage };
        },
      },
    ],
  },
];
